import { Typography } from '../../components/primitives';
import { testId } from '../../utils';
import { useTranslation } from '@rpi/i18n';
import React from 'react';

type VolumeDiscountCellProps = {
  'data-testid': string;
  minUnits: number | undefined;
  maxUnits: number | undefined;
  discountPercentage: number | undefined;
};

export const VolumeDiscountCell = ({
  'data-testid': dataTestId,
  minUnits,
  maxUnits,
  discountPercentage,
}: VolumeDiscountCellProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.cart' });
  const quantityRange = maxUnits
    ? `${minUnits}-${maxUnits} ${t('units')}`
    : `${minUnits}+ ${t('units')}`;
  const discountPercentageDefined = discountPercentage ?? 0;
  const formattedDiscountPercentage = `${discountPercentageDefined * 100}%`;

  return (
    <div
      {...testId(dataTestId, 'volume-discount-cell')}
      className="bg-gray-lightest p-4"
    >
      <Typography variant="body">{quantityRange}</Typography>
      <div className="p-1"></div>
      <Typography variant="title-large" className="text-black-dark">
        {formattedDiscountPercentage}
      </Typography>
    </div>
  );
};
